/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type DeleteApprovedLeaveResponse = {
  success: boolean;
  message?: string;
  data?: any;
};

export const deleteApprovedLeave = async (
  id: string
): Promise<DeleteApprovedLeaveResponse> =>
  (
    await customAxios.delete<DeleteApprovedLeaveResponse>(
      `/leaves/delete-approved-leave/${id}`
    )
  ).data;

export const useDeleteApprovedLeave = () => {
  const queryClient = useQueryClient();

  return useMutation<DeleteApprovedLeaveResponse, AxiosError, string>(
    deleteApprovedLeave,
    {
      onSuccess: (res) => {
        showNotification({
          title: "Leave Deleted",
          message: res.message ?? "Leave deleted successfully and balance reverted.",
          color: "green",
        });

        queryClient.invalidateQueries(["leaves", "requests"]);
        queryClient.invalidateQueries(["leaves", "balance"]);
      },
      onError: (error) => {
        showNotification({
          title: "Error Deleting Leave",
          message:
            (error.response?.data as { message?: string })?.message ??
            error.message ??
            "Failed to delete leave",
          color: "red",
        });
      },
      retry: 1,
    }
  );
};
